import * as actions from "./actions";
import * as components from "./components";
import reducer from "./reducer";
import * as selectors from "./selectors";

export default { actions, components, reducer, selectors };
